import { ClaimsFilters } from './types';

interface ClaimsFilterBarProps {
    games: { id: string; name: string }[];
    filters: ClaimsFilters;
    onFilterChange: (filters: ClaimsFilters) => void;
}

export function ClaimsFilterBar({ games, filters, onFilterChange }: ClaimsFilterBarProps) {
    const inputClass = 'px-3 py-2 border border-border rounded-lg bg-surface text-text-primary text-sm min-w-0';

    return (
        <div className="flex flex-wrap gap-4 mb-6">
            <select
                value={filters.gameId}
                onChange={(e) => onFilterChange({ ...filters, gameId: e.target.value })}
                className={`${inputClass} w-full sm:w-auto`}
            >
                <option value="">All Games</option>
                {games.map((game) => (
                    <option key={game.id} value={game.id}>
                        {game.name}
                    </option>
                ))}
            </select>

            <select
                value={filters.status}
                onChange={(e) => onFilterChange({ ...filters, status: e.target.value })}
                className={`${inputClass} w-full sm:w-auto`}
            >
                <option value="">All Statuses</option>
                <option value="pending">Pending</option>
                <option value="approved">Approved</option>
                <option value="rejected">Rejected</option>
            </select>

            <div className="flex items-center gap-2 w-full sm:w-auto">
                <label className="text-sm text-text-secondary">From</label>
                <input
                    type="date"
                    value={filters.startDate}
                    onChange={(e) => onFilterChange({ ...filters, startDate: e.target.value })}
                    className={`${inputClass} w-full sm:w-auto`}
                />
            </div>

            <div className="flex items-center gap-2 w-full sm:w-auto">
                <label className="text-sm text-text-secondary">To</label>
                <input
                    type="date"
                    value={filters.endDate}
                    onChange={(e) => onFilterChange({ ...filters, endDate: e.target.value })}
                    className={`${inputClass} w-full sm:w-auto`}
                />
            </div>
        </div>
    );
}
